(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Abby Home: all 35 Kigali sectors (Nyarugenge, Kicukiro, Gasabo districts), used to
  // match a reverse-geocoded address (see handlePosition below) against a real delivery
  // area, as the source list for the Neighborhood dropdown above, and (via lat/lng) as
  // the nearest-sector fallback when Nominatim's address fields don't name-match cleanly.
  // Coordinates are sector centroids cross-referenced across independent sources, not
  // estimated from the old 16-area list (which caused a real mismatch: a customer in
  // Rusororo was matched to Kanombe because Rusororo wasn't in that list at all).
  var ABBY_KIGALI_SECTORS = [
    { name: 'Bumbogo', value: 'Bumbogo, Kigali', lat: -1.8878, lng: 30.1559 },
    { name: 'Gahanga', value: 'Gahanga, Kigali', lat: -2.0314, lng: 30.1094 },
    { name: 'Gatenga', value: 'Gatenga, Kigali', lat: -1.9981, lng: 30.0828 },
    { name: 'Gatsata', value: 'Gatsata, Kigali', lat: -1.9219, lng: 30.0422 },
    { name: 'Gikomero', value: 'Gikomero, Kigali', lat: -1.8747, lng: 30.2289 },
    { name: 'Gikondo', value: 'Gikondo, Kigali', lat: -1.9731, lng: 30.0786 },
    { name: 'Gisozi', value: 'Gisozi, Kigali', lat: -1.9178, lng: 30.0611 },
    { name: 'Gitega', value: 'Gitega, Kigali', lat: -1.9534, lng: 30.0551 },
    { name: 'Jabana', value: 'Jabana, Kigali', lat: -1.8642, lng: 30.0639 },
    { name: 'Jali', value: 'Jali, Kigali', lat: -1.8822, lng: 30.0164 },
    { name: 'Kacyiru', value: 'Kacyiru, Kigali', lat: -1.9375, lng: 30.0803 },
    { name: 'Kagarama', value: 'Kagarama, Kigali', lat: -1.9975, lng: 30.1133 },
    { name: 'Kanombe', value: 'Kanombe, Kigali', lat: -1.9975, lng: 30.1447 },
    { name: 'Kanyinya', value: 'Kanyinya, Kigali', lat: -1.9178, lng: 30.0025 },
    { name: 'Kicukiro', value: 'Kicukiro, Kigali', lat: -1.9717, lng: 30.0969 },
    { name: 'Kigali', value: 'Kigali Sector, Kigali', lat: -1.9497, lng: 30.0586 },
    { name: 'Kigarama', value: 'Kigarama, Kigali', lat: -1.9875, lng: 30.0646 },
    { name: 'Kimihurura', value: 'Kimihurura, Kigali', lat: -1.9542, lng: 30.0881 },
    { name: 'Kimironko', value: 'Kimironko, Kigali', lat: -1.9383, lng: 30.1242 },
    { name: 'Kimisagara', value: 'Kimisagara, Kigali', lat: -1.9529, lng: 30.0461 },
    { name: 'Kinyinya', value: 'Kinyinya, Kigali', lat: -1.9089, lng: 30.0964 },
    { name: 'Mageragere', value: 'Mageragere, Kigali', lat: -2.0419, lng: 30.0361 },
    { name: 'Masaka', value: 'Masaka, Kigali', lat: -2.0222, lng: 30.2031 },
    { name: 'Muhima', value: 'Muhima, Kigali', lat: -1.9412, lng: 30.0609 },
    { name: 'Ndera', value: 'Ndera, Kigali', lat: -1.9333, lng: 30.1867 },
    { name: 'Nduba', value: 'Nduba, Kigali', lat: -1.8511, lng: 30.1125 },
    { name: 'Niboye', value: 'Niboye, Kigali', lat: -1.9761, lng: 30.1136 },
    { name: 'Nyakabanda', value: 'Nyakabanda, Kigali', lat: -1.9695, lng: 30.0450 },
    { name: 'Nyamirambo', value: 'Nyamirambo, Kigali', lat: -1.9925, lng: 30.0431 },
    { name: 'Nyarugenge', value: 'Nyarugenge, Kigali', lat: -1.9568, lng: 30.0643 },
    { name: 'Nyarugunga', value: 'Nyarugunga, Kigali', lat: -1.9744, lng: 30.1578 },
    { name: 'Remera', value: 'Remera, Kigali', lat: -1.9475, lng: 30.1058 },
    { name: 'Rusororo', value: 'Rusororo, Kigali', lat: -1.9364, lng: 30.2358 },
    { name: 'Rutunga', value: 'Rutunga, Kigali', lat: -1.8250, lng: 30.1744 },
    { name: 'Rwezamenyo', value: 'Rwezamenyo, Kigali', lat: -1.9713, lng: 30.0526 }
  ];

  // Abby Home: rough center + generous radius covering all three Kigali districts
  // (outlying sectors like Rutunga, Nduba, Gahanga, Mageragere sit 15-20km+ out), used
  // as a first-pass delivery geofence before the more precise Nominatim/sector match.
  var ABBY_KIGALI_CENTER = { lat: -1.9441, lng: 30.0619 };
  var ABBY_KIGALI_RADIUS_KM = 25;

  function abbyHaversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  var ABBY_WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var ABBY_OPEN_MINUTES = (8 * 60) + 30;
  var ABBY_CLOSE_MINUTES = 18 * 60;
  var ABBY_TURNAROUND_MINUTES = 180;

  function abbyGetKigaliMinutesAndDay() {
    var now = new Date();
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Africa/Kigali',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    });
    var map = {};
    fmt.formatToParts(now).forEach(function (p) { map[p.type] = p.value; });
    var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var hour = parseInt(map.hour, 10);
    if (hour === 24) hour = 0;
    var minute = parseInt(map.minute, 10);
    return { weekday: weekdayMap[map.weekday], minutes: (hour * 60) + minute };
  }

  function abbyFormatClock(totalMinutes) {
    var h = Math.floor(totalMinutes / 60) % 24;
    var m = totalMinutes % 60;
    var ampm = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12;
    if (h12 === 0) h12 = 12;
    var mm = m < 10 ? '0' + m : '' + m;
    return h12 + ':' + mm + ' ' + ampm;
  }

  function abbyComputeEta() {
    var now = abbyGetKigaliMinutesAndDay();
    var isWorkingDay = now.weekday >= 1 && now.weekday <= 6;

    if (isWorkingDay && now.minutes >= ABBY_OPEN_MINUTES && now.minutes < ABBY_CLOSE_MINUTES) {
      // Open right now: the 3-hour SLA clock starts this instant.
      return 'Today, ' + abbyFormatClock(now.minutes + ABBY_TURNAROUND_MINUTES);
    }

    if (isWorkingDay && now.minutes < ABBY_OPEN_MINUTES) {
      // Not open yet, but opens later today: the SLA clock starts at today's opening.
      return 'Today, ' + abbyFormatClock(ABBY_OPEN_MINUTES + ABBY_TURNAROUND_MINUTES);
    }

    // Closed for the rest of today (after hours, or it's Sunday): roll to the next working day.
    var daysAhead = 1;
    var nextWeekday = (now.weekday + daysAhead) % 7;
    if (nextWeekday === 0) {
      daysAhead = 2;
      nextWeekday = (now.weekday + daysAhead) % 7;
    }

    var dayLabel = daysAhead === 1 ? 'Tomorrow' : ABBY_WEEKDAY_NAMES[nextWeekday];
    return dayLabel + ', ' + abbyFormatClock(ABBY_OPEN_MINUTES + ABBY_TURNAROUND_MINUTES);
  }

  class LocationPicker extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.header__location-trigger');
      this.panel = this.querySelector('.header__location-panel');
      this.modeSelect = this.querySelector('[data-mode-select]');
      this.panels = this.querySelectorAll('[data-mode-panel]');
      this.modeLabel = this.querySelector('.header__location-mode');
      this.valueLabel = this.querySelector('[data-location-value]');
      this.saveBtn = this.querySelector('[data-save-location]');
      this.geoBtn = this.querySelector('[data-use-geolocation]');
      this.statusEl = this.querySelector('[data-location-status]');
      this.areaSelect = this.querySelector('[data-area-select]');
      this.freetextWrap = this.querySelector('[data-freetext-wrap]');
      this.freetextInput = this.querySelector('#AbbyDeliveryFreetext');
      this.etaTrigger = this.querySelector('[data-location-eta]');
      this.pickupEtaEl = this.querySelector('[data-pickup-eta]');
      this.deliveryEtaEl = this.querySelector('[data-delivery-eta]');
      this.hasDeliveryLocation = false;
      this.currentMode = 'pickup';
    }

    connectedCallback() {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });

      if (this.modeSelect) {
        this.modeSelect.addEventListener('change', () => this.setMode(this.modeSelect.value));
      }

      this.saveBtn.addEventListener('click', () => this.saveDelivery());

      if (this.geoBtn) {
        this.geoBtn.addEventListener('click', () => this.useGeolocation());
      }

      if (this.areaSelect) {
        this.areaSelect.addEventListener('change', () => this.handleAreaChange());
      }

      this.outsideClickHandler = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.escHandler = (event) => {
        if (event.key === 'Escape') this.close();
      };

      document.addEventListener('click', this.outsideClickHandler);
      document.addEventListener('keydown', this.escHandler);

      this.restore();

      this.etaInterval = setInterval(() => this.updateEta(), 60000);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.outsideClickHandler);
      document.removeEventListener('keydown', this.escHandler);

      if (this.etaInterval) {
        clearInterval(this.etaInterval);
      }
    }

    toggle() {
      if (this.panel.hidden) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    setMode(mode) {
      this.currentMode = mode;

      if (this.modeSelect) {
        this.modeSelect.value = mode;
      }

      this.panels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-mode-panel') !== mode;
      });

      this.modeLabel.textContent = mode === 'pickup' ? 'Pickup' : 'Delivery';

      try {
        localStorage.setItem('abbyHomeLocationMode', mode);
      } catch (e) {}

      if (mode === 'pickup') {
        this.valueLabel.textContent = 'UTC, Kigali City Centre';
      } else {
        this.restoreDeliveryLabel();
      }

      this.updateEta();
    }

    handleAreaChange() {
      const isOther = this.areaSelect.value === '__other__';
      if (this.freetextWrap) this.freetextWrap.hidden = !isOther;
      if (isOther && this.freetextInput) this.freetextInput.focus();

      if (this.areaSelect.value && !isOther) {
        // A real sector was picked directly from the dropdown — apply and auto-close,
        // same pattern as the geolocation flow below. "Other area" still needs the Save
        // button since it requires typing an address first.
        this.saveDelivery();
        this.showStatus('Location set ✓');
        setTimeout(() => {
          this.hideStatus();
          this.close();
        }, 900);
      }
    }

    findNearestArea(lat, lng) {
      let best = null;
      let bestDist = Infinity;
      ABBY_KIGALI_SECTORS.forEach((area) => {
        const d = abbyHaversineKm(lat, lng, area.lat, area.lng);
        if (d < bestDist) {
          bestDist = d;
          best = area;
        }
      });
      return { area: best, distanceKm: bestDist };
    }

    async handlePosition(position) {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      // Geofence: reject anything well outside Kigali before ever calling Nominatim.
      const distFromCenter = abbyHaversineKm(lat, lng, ABBY_KIGALI_CENTER.lat, ABBY_KIGALI_CENTER.lng);
      if (distFromCenter > ABBY_KIGALI_RADIUS_KM) {
        this.showStatus("We're currently not able to deliver to your location — please choose Pickup instead.");
        return false;
      }

      let matchedLabel = null;
      let matchedValue = null;

      try {
        const url = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + lat + '&lon=' + lng + '&zoom=14&addressdetails=1';
        const res = await fetch(url, { headers: { 'Accept-Language': 'en' } });
        const data = await res.json();
        const addr = (data && data.address) || {};

        // Belt-and-braces: if Nominatim is confident this isn't Rwanda, treat it as out of area
        // even if it slipped inside the radius geofence above.
        if (addr.country_code && addr.country_code.toLowerCase() !== 'rw') {
          this.showStatus("We're currently not able to deliver to your location — please choose Pickup instead.");
          return false;
        }

        const candidates = [addr.suburb, addr.neighbourhood, addr.quarter, addr.residential, addr.hamlet, addr.village, addr.town, addr.city_district, addr.municipality, addr.county, addr.state_district].filter(Boolean);
        for (let i = 0; i < candidates.length && !matchedLabel; i++) {
          const hit = ABBY_KIGALI_SECTORS.find((s) => candidates[i].toLowerCase().indexOf(s.name.toLowerCase()) !== -1);
          if (hit) {
            matchedLabel = hit.name;
            matchedValue = hit.value;
          }
        }
      } catch (e) {
        // Nominatim unreachable — fall through to the offline nearest-area fallback below.
      }

      if (matchedLabel) {
        this.applyLocation(matchedLabel, matchedValue);
        if (this.areaSelect) this.areaSelect.value = matchedValue;
      } else {
        const match = this.findNearestArea(lat, lng);
        if (match.area && match.distanceKm < 15) {
          this.applyLocation(match.area.name, match.area.value);
          if (this.areaSelect) this.areaSelect.value = match.area.value;
        } else {
          const mapsQuery = lat.toFixed(5) + ',' + lng.toFixed(5);
          this.applyLocation('Current location', mapsQuery);
        }
      }

      this.setMode('delivery');
      return true;
    }

    autoDetectLocation() {
      if (!('geolocation' in navigator)) return;
      navigator.geolocation.getCurrentPosition(
        (position) => this.handlePosition(position),
        () => {},
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
      );
    }

    useGeolocation() {
      if (!('geolocation' in navigator)) {
        this.showStatus("Location isn't supported on this browser — please choose your area below.");
        return;
      }

      this.showStatus('Finding your location…');

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.handlePosition(position).then((ok) => {
            if (ok) {
              // Auto-confirm: location is already applied inside handlePosition, so just
              // flash success and close the panel — no extra "Use this location" click needed.
              this.showStatus('Location set ✓');
              setTimeout(() => {
                this.hideStatus();
                this.close();
              }, 1200);
            } else {
              // handlePosition already showed the out-of-area / undeliverable message.
              setTimeout(() => this.hideStatus(), 4000);
            }
          });
        },
        () => {
          this.showStatus("Couldn't access your location — please choose your area below.");
          setTimeout(() => this.hideStatus(), 4000);
        },
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
      );
    }

    showStatus(text) {
      if (!this.statusEl) return;
      this.statusEl.textContent = text;
      this.statusEl.hidden = false;
    }

    hideStatus() {
      if (!this.statusEl) return;
      this.statusEl.hidden = true;
    }

    applyLocation(label, mapsQuery) {
      this.valueLabel.textContent = label;

      try {
        localStorage.setItem('abbyHomeDeliveryLocation', label);
      } catch (e) {}

      this.hasDeliveryLocation = true;
      this.updateEta();
    }

    saveDelivery() {
      let label = '';
      let mapsQuery = '';

      if (this.areaSelect && this.areaSelect.value && this.areaSelect.value !== '__other__') {
        label = this.areaSelect.options[this.areaSelect.selectedIndex].textContent.trim();
        mapsQuery = this.areaSelect.value;
      } else if (this.freetextInput && this.freetextInput.value.trim()) {
        label = this.freetextInput.value.trim();
        mapsQuery = /kigali|rwanda/i.test(label) ? label : label + ', Kigali, Rwanda';
      } else {
        return;
      }

      this.applyLocation(label, mapsQuery);
    }

    restoreDeliveryLabel() {
      let saved = null;
      try {
        saved = localStorage.getItem('abbyHomeDeliveryLocation');
      } catch (e) {}

      if (saved) {
        this.valueLabel.textContent = saved;
      } else {
        this.valueLabel.textContent = 'Set your location';
      }
    }

    updateEta() {
      const etaText = abbyComputeEta();

      if (this.etaTrigger) {
        this.etaTrigger.textContent = (this.currentMode === 'delivery' ? 'Arrives: ' : 'Ready: ') + etaText;
      }

      if (this.pickupEtaEl) {
        this.pickupEtaEl.textContent = etaText;
      }

      if (this.deliveryEtaEl) {
        this.deliveryEtaEl.textContent = etaText;
      }
    }

    restore() {
      let mode = null;
      try {
        mode = localStorage.getItem('abbyHomeLocationMode');
      } catch (e) {}

      let savedDelivery = null;
      try {
        savedDelivery = localStorage.getItem('abbyHomeDeliveryLocation');
      } catch (e) {}
      this.hasDeliveryLocation = !!savedDelivery;

      if (mode) {
        this.setMode(mode);
        return;
      }

      this.setMode('pickup');

      if ('permissions' in navigator && navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({ name: 'geolocation' }).then((status) => {
          if (status.state === 'granted') {
            this.autoDetectLocation();
          }
        }).catch(() => {});
      }
    }
  }

  customElements.define('location-picker', LocationPicker);

  } catch(e) { console.error(e); }
})();
})();
